import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { media, theme } from '@vfit/shared/themes';

export const Category = styled.div<{ headerShort: boolean | undefined }>`
  font-family: ${theme.typography.fontFamily.secondary};
  max-width: 70%;
  margin-bottom: ${({ headerShort }) => (headerShort ? theme.spacing.sm : '10px')};
  font-size: ${theme.typography.fontSize.body1};
  line-height: ${theme.typography.lineHeight.body2};
  font-weight: ${theme.typography.fontWeight.regular};
  color: ${theme.colors.bg.secondary};

  ${media.tablet`
    margin-bottom: ${theme.spacing.lg};
  `}
`;

export const Title = styled.div<{ headerShort: boolean | undefined }>`
  max-width: 70%;
  margin-bottom: ${theme.spacing.lg};
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.extrabold};
  font-size: ${theme.typography.fontSize.h1};
  line-height: ${theme.typography.lineHeight.display1};
  color: ${theme.colors.text.inverse};

  p {
    margin: inherit;
  }

  ${media.tablet`
    font-size: ${theme.typography.fontSize.display2};
    line-height: ${theme.typography.lineHeight.display1};

    h2 {
      font-size: ${theme.typography.fontSize.body1};
      line-height: ${theme.typography.lineHeight.body2};
    }

    p {
      margin: inherit;
    }

    h4 {
      font-size: ${theme.typography.fontSize.h4};
      line-height: ${theme.typography.lineHeight.h4};
    }

    h5 {
      font-size: ${theme.typography.fontSize.h6};
      line-height: ${theme.typography.lineHeight.h6};
    }
  `}

  ${media.desktop`
    font-size: ${theme.typography.fontSize.display1};
    line-height: ${theme.typography.lineHeight.display1};
    p {
      margin: inherit;
    }

    h4 {
      font-size: ${theme.typography.fontSize.h1};
      line-height: ${theme.typography.lineHeight.h1};
    }

    h5 {
      font-size: ${theme.typography.fontSize.h6};
      line-height: ${theme.typography.lineHeight.h6};
    }
  `}
`;

export const TitleLite = styled.div<{ headerShort: boolean | undefined }>`
  font-family:${theme.typography.fontFamily.primary};
  font-weight:${theme.typography.fontWeight.extrabold};
  font-size:${theme.typography.fontSize.h4};
  line-height:${theme.typography.lineHeight.h4};
  color: ${theme.colors.text.primary};

  p {
    margin: inherit;
  }

  ${media.tablet`
    h2 {
      font-family:${theme.typography.fontFamily.primary};
      font-weight:${theme.typography.fontWeight.extrabold};
      font-size:${theme.typography.fontSize.h4};
      line-height:${theme.typography.lineHeight.h4};
      color: ${theme.colors.text.primary};
    }

    p {
      margin: inherit;
      font-family:${theme.typography.fontFamily.primary};
      font-weight:${theme.typography.fontWeight.extrabold};
      font-size:${theme.typography.fontSize.h4};
      line-height:${theme.typography.lineHeight.h4};
    }

    h4 {
      font-family:${theme.typography.fontFamily.primary};
      font-weight:${theme.typography.fontWeight.extrabold};
      font-size:${theme.typography.fontSize.h4};
      line-height:${theme.typography.lineHeight.h4};
    }

    h5 {
      font-family:${theme.typography.fontFamily.primary};
      font-weight:${theme.typography.fontWeight.extrabold};
      font-size:${theme.typography.fontSize.h4};
      line-height:${theme.typography.lineHeight.h4};
      color: ${theme.colors.text.primary};
    }
  `}

  ${media.desktop`
    p {
      font-family:${theme.typography.fontFamily.primary};
      font-weight:${theme.typography.fontWeight.extrabold};
      font-size:${theme.typography.fontSize.h4};
      line-height:${theme.typography.lineHeight.h4};
      margin: inherit;
    }

    h4 {
      font-family:${theme.typography.fontFamily.primary};
      font-weight:${theme.typography.fontWeight.extrabold};
      font-size:${theme.typography.fontSize.h4};
      line-height:${theme.typography.lineHeight.h4};
    }

    h5 {
      font-family:${theme.typography.fontFamily.primary};
      font-weight:${theme.typography.fontWeight.extrabold};
      font-size:${theme.typography.fontSize.h4};
      line-height:${theme.typography.lineHeight.h4};
    }
  `}
`;

export const Description = styled.div<{ headerShort: boolean | undefined }>`
  font-family: ${theme.typography.fontFamily.secondary};
  max-width: 70%;
  margin-bottom: ${({ headerShort }) => (headerShort ? theme.spacing.xl : '35px')};
  font-size: ${theme.typography.fontSize.body1};
  line-height: ${theme.typography.lineHeight.body2};
  font-weight: ${theme.typography.fontWeight.regular};
  color: ${theme.colors.bg.secondary};

  span {
    display: flex;
    font-weight: ${theme.typography.fontWeight.regular};
    color: ${theme.colors.text.inverse};
    align-items: baseline;
  }

  ${media.desktop`
    h2 {
        font-size: ${theme.typography.fontSize.body1};
  line-height: ${theme.typography.lineHeight.body2};
    }
  `}
`;

export const DescriptionLite = styled.div<{ headerShort: boolean | undefined }>`
  font-size: ${theme.typography.fontSize.body1};
  line-height: ${theme.typography.lineHeight.body2};
  color: ${theme.colors.text.primary};

  p {
    margin: inherit;
  }

  ${media.desktop`
    h2 {
      font-size: ${theme.typography.fontSize.h4};
      line-height: ${theme.typography.lineHeight.h4};
      font-weight: ${theme.typography.fontWeight.light};
      color: ${theme.colors.text.primary};
    }

    p {
      margin: inherit;
      font-size: ${theme.typography.fontSize.h4};
      line-height: ${theme.typography.lineHeight.h4};
      font-weight: ${theme.typography.fontWeight.light};
      color: ${theme.colors.text.primary};
    }

    h4 {
      font-size: ${theme.typography.fontSize.h4};
      line-height: ${theme.typography.lineHeight.h4};
      font-weight: ${theme.typography.fontWeight.light};
      color: ${theme.colors.text.primary};
    }

    h5 {
      font-size: ${theme.typography.fontSize.h4};
      line-height: ${theme.typography.lineHeight.h4};
      font-weight: ${theme.typography.fontWeight.light};
      color: ${theme.colors.text.primary};
    }
  `}

  ${media.desktop`
    p {
      font-size: ${theme.typography.fontSize.h4};
      line-height: ${theme.typography.lineHeight.h4};
      font-weight: ${theme.typography.fontWeight.light};
      margin: inherit;
    }

    h4 {
      font-size: ${theme.typography.fontSize.h4};
      line-height: ${theme.typography.lineHeight.h4};
      font-weight: ${theme.typography.fontWeight.light};
      color: ${theme.colors.text.primary};
    }

    h5 {
      font-size: ${theme.typography.fontSize.h4};
      line-height: ${theme.typography.lineHeight.h4};
      font-weight: ${theme.typography.fontWeight.light};
      color: ${theme.colors.text.primary};
    }
  `}
`;

export const SlideProductContainer = styled.div<{ shortHero?: boolean; haveDivider: boolean }>`
  position: relative;
  margin-bottom: ${({ haveDivider }) => (!haveDivider ? '0px' : '50px')};
  min-height: ${({ shortHero }) => (shortHero ? '320px' : '442px')};

  
  ${media.withProps.tablet<{ shortHero?: boolean; haveDivider: boolean }>(({ shortHero, haveDivider }) => `
    margin-bottom: ${!haveDivider ? '0px' : '80px'};
    min-height: ${shortHero ? '480px' : '800px'};
  `)}

  ${media.withProps.desktop<{ shortHero?: boolean; haveDivider: boolean }>(({ shortHero, haveDivider }) => `
    min-height: ${shortHero ? '480px' : '680px'};
  `)}
`;

export const DivImgContainer = styled.div<{ isApp?: boolean; absolute: boolean }>`
  height: 100%;
  width: 100%;
  min-height: 100%;
  min-width: 100%;
  overflow: hidden;
  z-index: -1;
  object-fit: cover;
  object-position: center;
  border-radius: ${(props) => (props.isApp ? '0 0 12px 12px' : '0 0 20px 20px')};
  position: ${(props) => (props.absolute ? 'absolute' : 'relative')};
  top: ${(props) => (props.absolute ? 0 : '')};
  left: ${(props) => (props.absolute ? 0 : '')};

  ${media.tablet`
    border-radius: 0 0 30px 30px;
  `}

  ${media.desktop`
    border-radius: 0 0 30px 30px;
  `}

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: inline-block;
    background: linear-gradient(1.14deg, rgba(0, 0, 0, 4%) 11.28%, rgba(0, 0, 0, 0%) 75.72%);
  }
`;

export const SlideProductNavigation = styled.div<{ shortHero: boolean }>`
  margin-bottom: ${({ shortHero }) => (shortHero ? theme.spacing.xl : '22px')};

  display: flex;
  .back {
    width: inherit;
    display: flex;
    cursor: pointer;
    margin: 0;
    appearance: none;
    background: none;
    border: none;
    font-family: inherit;
    font-size: inherit;
    padding: 0;
  }

  div {
    transform: rotate(180deg);
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 9px;
      height: 16px;

      path {
        stroke: white;
      }
    }
  }

  span {
    font-family: ${theme.typography.fontFamily.secondary};
    font-weight: ${theme.typography.fontWeight.regular};
    font-size: ${theme.typography.fontSize.body1};
    line-height: ${theme.typography.lineHeight.body2};
    color: ${theme.colors.text.inverse};
    margin-left: ${theme.spacing.md};
  }

  button {
    border: 0;
    display: flex;
    cursor: pointer;
  }

  ${media.withProps.tablet<{ shortHero?: boolean }>(({ shortHero }) => `
    margin-bottom: ${shortHero ? '56px' : '22px'};
  `)}

  ${media.withProps.desktop<{ shortHero?: boolean }>(({ shortHero }) => `
    margin-bottom: ${shortHero ? '40px' : '22px'};
  `)}
`;

export const SlideProductContent = styled.div<{
  shortHero: boolean | undefined;
  headerLite: boolean;
}>`
  margin-left: ${theme.spacing.xl};
  margin-right: ${theme.spacing.xl};
  padding-bottom: ${theme.spacing.xl};
  padding-top: ${({ shortHero, headerLite }) =>
    shortHero ? `${headerLite ? '80px' : theme.spacing.xl}` : `${headerLite ? '80px' : theme.spacing.xl}`};
  display: flex;
  flex-direction: column;
  height: 100%;

  ${media.withProps.tablet<{ shortHero?: boolean; headerLite: boolean }>(({ shortHero, headerLite }) => `
    padding-top: ${shortHero ? `${headerLite ? '112px' : theme.spacing['3xl']}` : `${headerLite ? '112px' : theme.spacing['3xl']}`};
  `)}

  ${media.desktop`
    margin-left: 80px;
  `}
`;

export const SlideProductContentTop = styled.div`
  width: 100%;
  flex: 0.8;

  ${media.tablet`
    flex: 0.9;
  `}

  ${media.desktop`
    flex: 0.8;
  `}
`;

export const SlideProductContentBottom = styled.div`
  position: absolute;
  display: flex;
  bottom: 23px;
  width: 100%;
  flex: 0.2;
  padding-bottom: 60px;
  justify-content: center;
  // z-index: 10;
  margin-left: -${theme.spacing.xl};

  ${media.tablet`
    padding-bottom: 0;
    margin-left: -${theme.spacing.xl};
    flex: 0.1;
  `}

  ${media.desktop`
    padding-bottom: 10px;
    margin-left: -80px;
  `}
`;

export const SlideProductText = styled.div`
  h2 {
    font-family: ${theme.typography.fontFamily.secondary};
    font-weight: ${theme.typography.fontWeight.regular};
    font-size: ${theme.typography.fontSize.body2};
    line-height: ${theme.typography.lineHeight.body2};
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: ${theme.colors.text.inverse};
    margin: 0 ${theme.spacing.xl};
  }

  h4 {
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.h5};
    line-height: ${theme.typography.lineHeight.h6};
    font-weight: ${theme.typography.fontWeight.extrabold};
    color: ${theme.colors.bg.secondary};
    margin: ${theme.spacing.xl} ${theme.spacing.xl} 0;
    max-width: none;
  }

  h5 {
    font-family: ${theme.typography.fontFamily.secondary};
    font-weight: ${theme.typography.fontWeight.bold};
    font-size: ${theme.typography.fontSize.body2};
    line-height: ${theme.typography.lineHeight.body2};
    color: ${theme.colors.text.disabled};
    margin: ${theme.spacing.sm} ${theme.spacing.xl} 0;
    max-width: none;
  }

  ${media.tablet`
    h2 {
      font-size: ${theme.typography.fontSize.body2};
      line-height: ${theme.typography.lineHeight.body2};
    }
  `}

  ${media.desktop`
    h2 {
      font-size: ${theme.typography.fontSize.body2};
      line-height: ${theme.typography.lineHeight.body2};
    }
  `}
`;

export const SlideProductLiteText = styled.div`
  text-align: center;
  margin-top: 80px;
  margin-bottom: 80px;
`;

export const ModalTitle = styled.div`
  div {
    margin: 0;
    margin-bottom: ${theme.spacing.lg};
  }
`;

export const ModalContent = styled.div`
  div {
    margin: 0;
  }
`;

export const SlideButtonsContainer = styled.div`
  display: flex;
  margin-top: ${theme.spacing.xl};
  flex-direction: column;

  button,
  a {
    min-width: 210px;
    width: auto;
    margin-bottom: 10px;
  }
  ${media.tablet`
    gap: 20px;
  `}
  ${media.desktop`
    flex-direction: row;
  `}
  gap: 15px;
`;

const commonRichTextStyles = css`
  b {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.extrabold};
  }

  img {
    cursor: text;
    vertical-align: baseline;
  }

  a {
    color: ${theme.colors.text.primary};
    font-weight: ${theme.typography.fontWeight.bold};

    &:hover {
      color: ${theme.colors.text.link};
    }
  }

  button {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.extrabold};
    font-size: ${theme.typography.fontSize.display5};
    
    color: ${theme.colors.text.brand};
    background: none;
    border: none;
    padding: 0;
    outline: inherit;

    span {
      font-family: ${theme.typography.fontFamily.secondary};
      font-weight: ${theme.typography.fontWeight.light};
      color: ${theme.colors.text.inverse}; 
      background-color: ${theme.colors.brand.primary};
      padding-left: ${theme.spacing.sm};
      padding-right: ${theme.spacing.sm};
      border-radius: 50%;
      cursor: pointer;
    }

    &:hover {
      span {
        background-color: ${theme.colors.text.linkHover};
      }
    }

    &:active {
      span {
        background-color: ${theme.colors.interactive.active};
      }
    }
  }
`;

export const ModalTitleText = styled.div`
  ${commonRichTextStyles}
  margin: 0;
  text-align: left;
  margin-top: ${theme.spacing.md}; 
  margin-bottom: ${theme.spacing.xl};
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.extrabold};
  font-size: ${theme.typography.fontSize.h2};
  line-height: ${theme.typography.lineHeight.h2};
`;
export const ModalContentText = styled.div`
  ${commonRichTextStyles}
  margin: 0;
  text-align: left;
  margin-top: ${theme.spacing.md}; 
  margin-bottom: ${theme.spacing.xl};
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.light};
  font-size: ${theme.typography.fontSize.body1};
  line-height: ${theme.typography.lineHeight.body2};
`;